"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 *
 * Based on:
 * https://github.com/ReactTraining/react-router
 *  /blob/bd3265a350cff2b4cabda5b52f307f74c9eca60b/packages/react-router/modules/Prompt.js
 */
var Prompt =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, (Prompt.__proto__ || Object.getPrototypeOf(Prompt)).apply(this, arguments));
  }

  _createClass(Prompt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var history = this.context.router.history;
      var _props = this.props,
          when = _props.when,
          message = _props.message;
      this.unblock = history.block(function (location, action) {
        var finalWhen = typeof when === 'function' ? when(location, action) : when;

        if (finalWhen) {
          return message;
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _unblock;

      var history = this.context.router.history;
      var _props2 = this.props,
          when = _props2.when,
          message = _props2.message;
      (_unblock = this.unblock) === null || _unblock === void 0 ? void 0 : _unblock.call(this);
      this.unblock = history.block(function (location, action) {
        var finalWhen = typeof when === 'function' ? when(location, action) : when;

        if (finalWhen) {
          return message;
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _unblock2;

      (_unblock2 = this.unblock) === null || _unblock2 === void 0 ? void 0 : _unblock2.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Prompt;
}(_react.default.Component);

Object.defineProperty(Prompt, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    when: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]).isRequired,
    message: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]).isRequired
  }
});
Object.defineProperty(Prompt, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    when: true
  }
});
Object.defineProperty(Prompt, "contextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    router: _propTypes.default.shape({
      history: _propTypes.default.shape({
        block: _propTypes.default.func.isRequired
      }).isRequired
    }).isRequired
  }
});
var _default = Prompt;
exports.default = _default;